import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";
import { KeyRound, ArrowLeft } from "lucide-react";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot", { email });
      setSent(true);
    } catch { toast.error("Erro ao enviar"); }
    finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16">
      <Link to="/entrar" className="text-sm text-slate-500 hover:text-[#0B2B62] inline-flex items-center gap-1 mb-6">
        <ArrowLeft className="w-4 h-4" /> Voltar ao login
      </Link>
      <div className="text-xs uppercase tracking-[0.18em] text-slate-500 flex items-center gap-1.5">
        <KeyRound className="w-3.5 h-3.5" /> Recuperar acesso
      </div>
      <h1 className="font-display font-bold text-3xl text-[#0B2B62] tracking-tight mt-1">Esqueci minha senha</h1>
      <p className="text-sm text-slate-500 mt-2">Enviaremos um link seguro (válido por 30 min) ao seu e-mail cadastrado.</p>

      {sent ? (
        <div className="mt-6 p-4 rounded-lg border border-green-200 bg-green-50 text-sm text-slate-700" data-testid="forgot-sent">
          Se o e-mail existir, enviamos as instruções. Verifique também a caixa de spam.
        </div>
      ) : (
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="text-sm font-medium text-slate-700">E-mail</label>
            <input data-testid="forgot-email" required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-1.5 w-full px-3 py-2.5 border border-slate-300 rounded-md outline-none focus:ring-2 focus:ring-[#0B2B62]" />
          </div>
          <button data-testid="forgot-submit" disabled={busy} type="submit"
            className="w-full py-3 bg-[#0B2B62] text-white rounded-md font-semibold hover:bg-slate-800 disabled:opacity-60">
            {busy ? "Enviando..." : "Enviar link de recuperação"}
          </button>
        </form>
      )}
    </div>
  );
};

export default ForgotPassword;
